// Blocks the add-to-cart submit until the fields inside are valid: event registration
// (snippets/envisage-registration-fields.liquid) or per-piece merch sizes (snippets/envisage-size-picks.liquid).
// Dawn's product form is `novalidate` and posts over fetch, so the browser never checks `required` on its own.
if (!customElements.get('envisage-registration')) {
  customElements.define(
    'envisage-registration',
    class EnvisageRegistration extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form) return;
        this.submitButton = this.form.querySelector('[type="submit"]');
        this.addButton = this.querySelector('[data-add-member]');
        this.onClick = this.onClick.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onPhoneInput = this.onPhoneInput.bind(this);
        this.submitButton?.addEventListener('click', this.onClick);
        this.addButton?.addEventListener('click', this.onAdd);
        this.addEventListener('input', this.onPhoneInput);
        // A size pick clears its row's "Pick a size" marker.
        this.addEventListener('change', (event) => event.target.closest('[data-size-group]')?.removeAttribute('data-missing'));
      }

      disconnectedCallback() {
        this.submitButton?.removeEventListener('click', this.onClick);
        this.addButton?.removeEventListener('click', this.onAdd);
        this.removeEventListener('input', this.onPhoneInput);
      }

      get optionalMembers() {
        return [...this.querySelectorAll('[data-optional-member]')];
      }

      // Shows the next optional member field. Hidden ones are disabled, so they aren't sent with the form.
      onAdd() {
        const next = this.optionalMembers.find((row) => row.hidden);
        if (!next) return;
        this.setShown(next, true);
        next.querySelector('input').focus();
        this.updateAddButton();
      }

      setShown(row, shown) {
        row.hidden = !shown;
        row.querySelector('input').disabled = !shown;
      }

      updateAddButton() {
        if (this.addButton) this.addButton.hidden = this.optionalMembers.every((row) => !row.hidden);
      }

      // Phone fields ([data-phone]) keep only digits: spaces, dashes and a +91 or 0 prefix are dropped as people type
      // or paste, and the number is cut at 10 digits. The field's pattern then requires a valid mobile number.
      onPhoneInput(event) {
        const field = event.target;
        if (!field.matches?.('[data-phone]')) return;
        let digits = field.value.replace(/\D/g, '');
        if (digits.length > 10 && digits.startsWith('91')) digits = digits.slice(2);
        else if (digits.length > 10 && digits.startsWith('0')) digits = digits.slice(1);
        digits = digits.slice(0, 10);
        if (field.value !== digits) field.value = digits;
      }

      // Moves filled optional names up and hides the empty rows, so the order has Member 7, 8... with no gaps
      // or blank entries.
      compactOptionalMembers() {
        const rows = this.optionalMembers;
        const names = rows.map((row) => row.querySelector('input').value.trim()).filter(Boolean);
        rows.forEach((row, i) => {
          row.querySelector('input').value = names[i] ?? '';
          this.setShown(row, i < names.length);
        });
        this.updateAddButton();
      }

      onClick(event) {
        this.compactOptionalMembers();
        const fields = [...this.querySelectorAll('input:not(:disabled)')];
        for (const field of fields) if (field.type !== 'radio') field.value = field.value.trim();
        if (fields.every((field) => field.checkValidity())) return;
        event.preventDefault();
        event.stopImmediatePropagation();

        // Size pills are hidden radios, so a browser bubble would point at nothing: mark the rows instead.
        const missingGroups = [...this.querySelectorAll('[data-size-group]')].filter(
          (group) => !group.querySelector('input:checked')
        );
        for (const group of missingGroups) group.setAttribute('data-missing', '');
        const firstInvalid = fields.find((field) => !field.checkValidity());
        if (firstInvalid?.type === 'radio') {
          firstInvalid.closest('[data-size-group]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          firstInvalid?.reportValidity();
        }
      }
    }
  );
}
